import { useIntl } from "react-intl";

import TabsContent from "@/components/adg4/tabs-content/src/tabs-content";
import { useLocalizedHref } from "@/libraries/web-framework";
import { DataEventProps } from "@/libraries/wpl/foundations/src";

const MarketingTabContent = () => {
    const intl = useIntl();

    const cardCtaText = intl.formatMessage({
        id: "HomePageTemplateV2.tab.marketing.card.linkText",
        defaultMessage: "Try it out"
    });

    const cardDataEventProps: DataEventProps = {
        "data-product-key": "home",
        "data-event-component": "linkButton",
        "data-event-container": "cardSection",
        "data-event": "clicked",
        "data-label": cardCtaText,
        "data-label-english": "Try it out"
    };

    return (
        <TabsContent
            className="homepage-tabs-content"
            contentList={[
                {
                    headerText: intl.formatMessage({
                        id: "HomePageTemplateV2.tab.marketing.header",
                        defaultMessage: "Bring marketing closer to product"
                    }),
                    bodyText: intl.formatMessage({
                        id: "HomePageTemplateV2.tab.marketing.bodytext",
                        defaultMessage:
                            "Track your work easily, run cross-functional marketing projects, and remove silos so you deliver real impact."
                    })
                }
            ]}
            contentLink={{
                linkText: intl.formatMessage({
                    id: "HomePageTemplateV2.tab.marketing.learnMore",
                    defaultMessage: "Learn more about Marketing"
                }),
                link: useLocalizedHref("/teams/marketing"),
                linkLabel: "Learn more about Marketing",
                productKey: "home"
            }}
            pictureProps={{
                image: {
                    src: "https://wac-cdn.atlassian.com/misc-assets/webp-images/marketing-main.webp",
                    alt: "",
                    height: 400,
                    width: 768
                }
            }}
            tabContentEyebrowText={intl.formatMessage({
                id: "HomePageTemplateV2.tab.marketing.resources",
                defaultMessage: "Get started with a template"
            })}
            cardsContent={[
                {
                    headerText: intl.formatMessage({
                        id: "HomePageTemplateV2.tab.marketing.card1.headerText",
                        defaultMessage: "Customer journey mapping"
                    }),
                    headerType: "h5",
                    bodyText: intl.formatMessage({
                        id: "HomePageTemplateV2.tab.marketing.card1.bodyText",
                        defaultMessage:
                            "Visualize how customers experience your product or service"
                    }),
                    ctaProps: {
                        primaryLinkProps: {
                            text: cardCtaText,
                            type: "basic",
                            href: useLocalizedHref(
                                "/software/confluence/templates/customer-journey-mapping"
                            ),
                            doesArrowAnimate: true,
                            dataEventProps: cardDataEventProps
                        }
                    },
                    pictureProps: {
                        image: {
                            src: "https://wac-cdn.atlassian.com/misc-assets/webp-images/marketing-card-1.webp",
                            alt: "",
                            height: 215,
                            width: 368
                        }
                    }
                },
                {
                    headerText: intl.formatMessage({
                        id: "HomePageTemplateV2.tab.marketing.card2.headerText",
                        defaultMessage: "Content management"
                    }),
                    headerType: "h5",
                    bodyText: intl.formatMessage({
                        id: "HomePageTemplateV2.tab.marketing.card2.bodyText",
                        defaultMessage:
                            "Oversee your marketing content lifecycle from draft to delivery"
                    }),
                    ctaProps: {
                        primaryLinkProps: {
                            text: cardCtaText,
                            type: "basic",
                            href: useLocalizedHref(
                                "/software/jira/templates/content-management"
                            ),
                            doesArrowAnimate: true,
                            dataEventProps: cardDataEventProps
                        }
                    },
                    pictureProps: {
                        image: {
                            src: "https://wac-cdn.atlassian.com/misc-assets/webp-images/marketing-card-2.webp",
                            alt: "",
                            height: 215,
                            width: 368
                        }
                    }
                },
                {
                    headerText: intl.formatMessage({
                        id: "HomePageTemplateV2.tab.marketing.card3.headerText",
                        defaultMessage: "Campaign management"
                    }),
                    headerType: "h5",
                    bodyText: intl.formatMessage({
                        id: "HomePageTemplateV2.tab.marketing.card3.bodyText",
                        defaultMessage:
                            "Track tasks and deadlines while managing end-to-end campaigns"
                    }),
                    ctaProps: {
                        primaryLinkProps: {
                            text: cardCtaText,
                            type: "basic",
                            href: useLocalizedHref(
                                "/software/jira/templates/campaign-management"
                            ),
                            doesArrowAnimate: true,
                            dataEventProps: cardDataEventProps
                        }
                    },
                    pictureProps: {
                        image: {
                            src: "https://wac-cdn.atlassian.com/misc-assets/webp-images/marketing-card-3.webp",
                            alt: "",
                            height: 215,
                            width: 368
                        }
                    }
                }
            ]}
        />
    );
};

export { MarketingTabContent };
